import { ConfirmModal } from '@/shared/ui/components';
import { useLoadingStore } from '@/shared/model';
import { t } from 'ttag';
import LoadingPage from './loadingPage/loadingPage';
import { AppRoutes } from './routes';
import { useApp } from './useApp';

/**
 * Root application shell rendering the global overlays and the route tree. Mounts the message and notification context holders and the loading page, shows a refresh-prompt confirm modal when a newer web app version is available and the prompt is not suppressed, then renders the application routes.
 *
 * @returns The application shell element.
 */
const App = () => {
  const {
    contextHolder,
    notiContextHolder,
    preventDisplayLatestUpdateModal,
    state,
    onClickRightButton,
  } = useApp();
  const loadingText = useLoadingStore((s) => s.loadingText);

  return (
    <>
      {contextHolder}
      {notiContextHolder}

      <LoadingPage loadingText={loadingText} />

      {!preventDisplayLatestUpdateModal && (
        <ConfirmModal
          isOpen={state.isOpenModal}
          onClickRightButton={onClickRightButton}
          rightButtonName={t`Refresh`}
          title={t`Latest Update`}
          question={t`The latest version of the web app is available. Please refresh your
            browser by clicking on Refresh or click CTRL+F5 on your keyboard`}
          buttonRightStyle="danger"
        />
      )}

      <AppRoutes />
    </>
  );
};

export default App;
